import { Account } from '../account/types'
import { Customer } from '../customer/types'

// origen principal del hilo de conversación (widget chat tienda → CHATBOT; formulario/contacto web genérico → WEB)
export enum SupportConversationChannel {
    WEB = 'WEB',
    CHATBOT = 'CHATBOT',
    EMAIL = 'EMAIL',
    WHATSAPP = 'WHATSAPP',
}

// quién puede ver el hilo en el tenant
export enum SupportConversationVisibility {
    INTERNAL = 'INTERNAL',
    MERCHANT = 'MERCHANT',
}

export enum SupportConversationPriority {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
    URGENT = 'URGENT',
}

export enum SupportConversationStatus {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING = 'PENDING',
}

export enum SupportConversationMessageDeliveryStatus {
    QUEUED = 'QUEUED',
    SENT = 'SENT',
    DELIVERED = 'DELIVERED',
    READ = 'READ',
    FAILED = 'FAILED',
}

export enum SupportConversationMessageAiAnalysisStatus {
    PENDING = 'PENDING',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
}

// Dirección del mensaje con respecto al sistema: entrante o saliente
export enum SupportConversationMessageDirection {
    INBOUND = 'INBOUND',
    OUTBOUND = 'OUTBOUND',
}

// Tipo de emisor del mensaje
export enum SupportConversationMessageSenderType {
    CUSTOMER = 'CUSTOMER',
    ACCOUNT_USER = 'ACCOUNT_USER',
    ANONYMOUS = 'ANONYMOUS',
    SYSTEM = 'SYSTEM',
    AI = 'AI',
}

export interface SupportConversation {
    id: string
    accountId: string
    subject?: string | null // Asunto opcional del hilo (para email o contacto web)
    channel: SupportConversationChannel // Canal principal de la conversación (email/whatsapp/web, etc.)
    assigneeId?: string | null // Asignación interna (agente/usuario de la cuenta que atiende la conversación)
    visibility: SupportConversationVisibility
    priority: SupportConversationPriority // Priorización operativa
    requiresMerchantAction: boolean // Indica si el comercio debe responder o tomar acción
    requiresInternalAction: boolean // Indica si el equipo interno debe intervenir (respuesta, etc.)
    customerId?: string | null // Identificador del cliente si está registrado en el sistema
    customerName?: string | null // Nombre del contacto (snapshot, no necesariamente el del Customer)
    customerLastname?: string | null // Apellido del contacto (snapshot)
    customerEmail?: string | null // Email del contacto (snapshot)
    customerPhone?: string | null // Teléfono del contacto (snapshot)
    status: SupportConversationStatus // Estado simple (string para mantenerlo liviano)
    lastMessageAt?: Date | null
    unreadForAgent: number // Mensajes no leídos por el agente interno
    unreadForCustomer: number // Mensajes no leídos por el cliente/comercio
    metadata?: Object | null // Metadatos flexibles (headers email, ids de chat, etc.)
    aiSuggestion?: Object | null // Sugerencias/Resumen asistidos por IA
    createdAt: Date
    updatedAt: Date
    deletedAt?: Date | null

    account: Account
    // assignee: AccountUser | null;
    customer: Customer | null
    messages: SupportConversationMessage[]
}

export interface SupportConversationMessage {
    id: string
    accountId: string
    conversationId: string
    direction: SupportConversationMessageDirection // Dirección simple (entrante/saliente)
    senderType: SupportConversationMessageSenderType // Tipo de emisor del mensaje (cliente, usuario interno, anónimo, sistema o IA)
    senderId?: string | null // Identificador del emisor cuando aplica (Customer o AccountUser). Puede ser null para anónimos, sistema o IA
    body: string
    isAiGenerated: boolean
    isSystem: boolean
    deliveryStatus: SupportConversationMessageDeliveryStatus // Estado de entrega (para OUTBOUND). Por defecto QUEUED para ser enviado por el canal.
    requiresAiAnalysis: boolean
    aiAnalysisStatus: SupportConversationMessageAiAnalysisStatus
    aiAnalyzedAt?: Date | null
    externalMessageId?: string | null // Identificadores de proveedor externo (messageId, threadId)
    externalThreadId?: string | null
    attachments?: Array<{
        url: string
        type?: string
        name?: string
        sizeBytes?: number
    }> // Adjuntos simples (urls o descriptores livianos)
    metadata?: Object | null // Metadatos flexibles (headers, payloads originales, etc.)
    createdAt: Date
    updatedAt: Date
    deletedAt?: Date | null
}
